<template>
  <div class="form-group slides-wrapper" v-click-outside="slideDeselected">
    <label>Slides</label>

    <draggable
      v-model="editableSlides"
      v-bind="dragOptions"
      class="slides-list"
      @end="updateSlides"
    >
      <div 
        v-for="(slide, index) in editableSlides" 
        :key="index" 
        class="slide"
        @click="slideSelected($event, slide)"
      >
        <div 
          class="slide__image" 
          :class="{'slide__image--no-bg' : slide.image === ''}"
        >
          <img v-if="slide.image !== ''" :src="`${$store.state.assetsPath}${convertToThumbnail(slide.image)}`" alt="">
        </div>
        <div class="slide__copy" :class="{'text-right' : dir === 'rtl'}" :key="lang">
          <div class="heading" v-html="slide.heading[lang]"></div>
          <div class="description" v-html="slide.description[lang]"></div>
        </div>
        
      </div>
    </draggable>

    <button type="button" class="btn btn-secondary" @click="addSlide">
      Add Slide
    </button>

    <!-- popup modal for slides -->
    <modal-edit-box 
      v-if="modalData.assetSelected.content.heading"
      :isVisible="isSlideSelected"
      :isArrowVisible="true"
      :xPos="modalData.assetSelected.xPos"
      :yPos="modalData.assetSelected.yPos"
      @update="updateSlides"
      @remove="removeSlide(modalData.assetSelected.content._id)"
    >
      <fieldset slot="input" class="form-group form-group--sm">
        <label class="modal-label">Heading</label>
        <input
          v-model="modalData.assetSelected.content.heading[lang]"
          type="text"
          class="form-control form-control-lg"
          placeholder="heading"
        />
      </fieldset>
      <fieldset slot="input" class="form-group form-group--sm">
        <label class="modal-label">Description</label>
        <textarea
          v-model="modalData.assetSelected.content.description[lang]"
          class="form-control"
          rows="4"
          placeholder="description"
        >
        </textarea>
      </fieldset>
      <fieldset slot="input" class="form-group form-group--sm mb-1">
        <input
          v-if="modalData.assetSelected.content.image"
          v-model="$store.state.assetsPath + modalData.assetSelected.content.image"
          type="text"
          class="form-control form-control-lg"
          placeholder="no image attached"
          readonly
        />
      </fieldset>
      <fieldset slot="input" class="form-group form-group--sm">
        <button
          class="btn btn-secondary btn-block btn-sm"
          @click="openAssetLibrary"
        >Attach Image</button>
      </fieldset>
      <fieldset slot="input" class="form-group form-group--sm">
        <button
          class="btn btn-danger btn-block btn-sm"
          @click="removeAsset"
        >Remove Image</button>
      </fieldset>
    </modal-edit-box>
    <!-- popup modal -->

    <asset-library
      v-if="isLibraryVisible"
      v-model="libraryModel"
      :multiple="false"
      :defaultCategory="''"
      @close="closeAssetLibrary"
    ></asset-library>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import AssetLibrary from '@/components/NewAssetLibrary'

export default {
  name: 'page-slider',

  components: {
    draggable,
    AssetLibrary
  },

  props: {
    dir: String,
    lang: String,
    slides: Array
  },

  data() {
    return {
      editableSlides: this.slides,

      isSlideSelected: false,

      modalData: {
        assetSelected: {
          content: {}
        }
      },

      isLibraryVisible: false,
      libraryModel: null
    }
  },

  watch: {
    libraryModel () {
      if (this.libraryModel) {
        this.modalData.assetSelected.content.image = this.libraryModel.path
      }
    },

    assets () {
      this.initLibraryModel()
    },

    value () {
      if (this.libraryModel) {
        if (this.multiple) {
          const libraryModelPaths = JSON.stringify(this.libraryModel.map(asset => {
            return asset.path
          }))
          const valuePaths = JSON.stringify(this.value)
          if (libraryModelPaths !== valuePaths) {
            this.initLibraryModel ()
          }
        } else {
          if (this.value !== this.libraryModel.path) {
            this.initLibraryModel ()
          }
        }
      } else {
        this.initLibraryModel()
      }
    }
  },

  computed: {
    assets () {
      return this.$store.state.assetLibrary.assets
    },

    dragOptions() {
      return {
        animation: 120,
        group: "slides",
        disabled: false,
        ghostClass: "ghostly"
      }
    },

    highestId() {
      let ids = [0]

      this.editableSlides.forEach((slide) => {
        if (!isNaN(slide._id)) {
          ids.push(slide._id)
        }
      });

      return (Math.max(...ids) + 1).toString()
    }
  },

  created () {
    this.$store.dispatch('FETCH_ASSETS')
  },

  methods: {
    addSlide() {
      const newSlide = {
        _id: this.highestId,
        heading: {
          en: ''
        },
        description: {
          en: ''
        },
        image: ""
      }

      this.editableSlides.push(newSlide)
    },

    updateSlides() {
      this.isSlideSelected = false;
      this.$emit('updateSlides', this.editableSlides)
    },

    removeSlide(id) {
      this.isSlideSelected = false;

      let remainingSlides = this.editableSlides.filter(function(item) {
        if (item._id != id) {
          return item
        }
      });

      this.editableSlides = remainingSlides
      this.$emit('updateSlides', this.editableSlides)
    },

    slideSelected(event, item) {
      this.isSlideSelected = true

      const modalWidth = 125

      let modalLeft = event.target.offsetLeft + modalWidth / 2
      let modalTop = event.target.offsetTop + event.target.offsetHeight + 7

      this.modalData.assetSelected.content = item
      this.modalData.assetSelected.type = "slide"
      this.modalData.assetSelected.xPos = modalLeft
      this.modalData.assetSelected.yPos = modalTop
    },

    slideDeselected() {
      this.isSlideSelected = false
    },

    closeAssetLibrary () {
      this.isLibraryVisible = false
    },

    openAssetLibrary () {
      if (!this.disabled)
        this.isLibraryVisible = true
    },

    initLibraryModel () {
      if (this.assets.length) {
        if (this.multiple) {
          let libraryModel = []
          this.value.forEach(path => {
            libraryModel.push(_.find(this.assets, asset => {
              return asset.path === path
            }))
          })
          this.libraryModel = libraryModel
        } else {
          this.libraryModel = _.find(this.assets, asset => {
            return asset.path === this.value
          })
        }
      }
    },

    removeAsset () {
      this.modalData.assetSelected.content.image = ''
    },

    convertToThumbnail (path) {
      const paths = path.split('/')
      if (path.substring(path.lastIndexOf('.')+1, path.length) == 'mp4') {
        return paths[0] + '/thumb_' + paths[1] + '.jpg'
      } else {
        return paths[0] + '/thumb_' + paths[1]
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.slides-wrapper {
  position: relative;
}

.slides-list {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
}

.slide {
  border: 1px solid #d4d4d4;
  border-radius: 4px;
  cursor: move;
  display: flex;
  height: 200px;
  margin: 10px;
  overflow: hidden;
  position: relative;
  width: 400px;

  &__image {
    pointer-events: none;
    width: 50%;

    &--no-bg {
      background-position: 0px 0px, 10px 10px;
      background-size: 20px 20px;
      background-image: 
      linear-gradient(45deg, #eee 25%, transparent 25%, transparent 75%, #eee 75%, #eee 100%),
      linear-gradient(45deg, #eee 25%, white 25%, white 75%, #eee 75%, #eee 100%);
    }

    img {
      height: 100%;
      object-fit: cover;
      width: 100%;
    }
  }

  &__copy {
    padding: 5px 8px;
    pointer-events: none;
    width: 50%;

    .heading {
      font-size: 12px;
      font-weight: 700;
      text-transform: uppercase;
    }

    .description {
      font-size: 12px;
      font-weight: 200;
    }
  }
}

.modal-label {
  color: #ffffff;
}
</style>
